import { render } from "./NovaCategoriaVoucher.vue?vue&type=template&id=fe94c73c&scoped=true"
import script from "./NovaCategoriaVoucher.vue?vue&type=script&lang=js"
export * from "./NovaCategoriaVoucher.vue?vue&type=script&lang=js"

import "./NovaCategoriaVoucher.vue?vue&type=style&index=0&id=fe94c73c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe94c73c"]])

export default __exports__